import styled from "styled-components"

export const CertificationsImage = styled.div`
  position: relative;
  padding: 0px 18px;
  @media only screen and (max-width: 768px) {
    padding: 16px 28px;
  }
  @media only screen and (max-width: 480px) {
    padding: 16px 28px;
  }

  /* &:hover {
    img {
      filter: grayscale(0);
      opacity: 1;
    }
  } */

  img {
    @media only screen and (max-width: 480px) {
      height: 50px;
    }
  }
`
